import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import React from 'react';

import { useTranslation } from '../../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  modal: {
    width: 650,
  },
  confirmModal: {
    '& [class*="MuiDialogContent-root"]': {
      paddingBottom: 5,
    },
  },
});

const SaveConfirmationModal = ({ isOpen, reportName, onClose, onConfirm }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  return (
    <>
      <Modal
        open={isOpen}
        className={classes.confirmModal}
        variant="warning"
        onClose={onClose}
        title={translateString('Confirm Save')}
        buttonProps={[
          {
            label: translateString('Cancel'),
          },
          {
            label: translateString('Save'),
            onClick: onConfirm,
          },
        ]}
        disableBackdropClick
      >
        <p>
          <b>{reportName} </b>
          {translateString('report model already exists. Do you want to overwrite it?')}
        </p>
      </Modal>
    </>
  );
};

export default SaveConfirmationModal;
